import React from 'react';
import { Navbar } from '../components/Navbar';
import './GameLeaderboardsPage.css';

// The boards for each game. `entries` is filled from the backend once the games report runs; until then each board
// shows its empty state.
const GAMES = [
    {
        id: 'solarflare',
        name: 'Solarflare',
        boards: [
            { id: 'speedrun', name: 'Speedruns', value: 'Time' },
            { id: 'stats', name: 'Player stats', value: 'Score' }
        ]
    },
    {
        id: 'spacejump',
        name: 'Space Jump',
        boards: [
            { id: 'fastest', name: 'Fastest clear', value: 'Time' },
            { id: 'jumps', name: 'Fewest jumps', value: 'Jumps' }
        ]
    }
];

export class GameLeaderboardsPage extends React.Component {

    state = {
        game: GAMES[0].id,
        board: GAMES[0].boards[0].id,
        entries: []
    };

    selectGame(game) {
        this.setState({ game: game.id, board: game.boards[0].id });
    }

    renderBoard(game, board) {
        let entries = this.state.entries;
        return (
            <div className="glb-board">
                <table className="glb-table">
                    <thead>
                        <tr>
                            <th className="glb-rank">Rank</th>
                            <th>Player</th>
                            <th className="glb-value">{board.value}</th>
                            <th className="glb-date">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((entry, i) => (
                            <tr key={entry.id}>
                                <td className="glb-rank">{i + 1}</td>
                                <td>{entry.player}</td>
                                <td className="glb-value">{entry.value}</td>
                                <td className="glb-date">{entry.date}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {entries.length === 0 ?
                    <p className="glb-empty">No {game.name} runs have been recorded yet. Check back soon!</p>
                    : null}
            </div>
        );
    }

    render() {
        let game = GAMES.find((g) => g.id === this.state.game);
        let board = game.boards.find((b) => b.id === this.state.board);

        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className={`glb-page glb-${game.id}`}>
                    <div className="glb-page-header">
                        <p className="glb-eyebrow">Clomp games</p>
                        <h1>Leaderboard</h1>
                        <p className="glb-intro">Speedruns and stats from Solarflare and Space Jump players.</p>
                    </div>
                    <div className="glb-tabs" role="tablist" aria-label="Game">
                        {GAMES.map((g) => (
                            <button key={g.id} type="button" role="tab" aria-selected={g.id === game.id}
                                className={g.id === game.id ? 'is-active' : ''} onClick={() => this.selectGame(g)}>
                                {g.name}
                            </button>
                        ))}
                    </div>
                    <div className="glb-boards" aria-label="Board">
                        {game.boards.map((b) => (
                            <button key={b.id} type="button" aria-pressed={b.id === board.id}
                                className={b.id === board.id ? 'is-active' : ''} onClick={() => this.setState({ board: b.id })}>
                                {b.name}
                            </button>
                        ))}
                    </div>
                    {this.renderBoard(game, board)}
                </div>
            </>
        );
    }

}
